import { Button } from '@mui/material';
import React, {} from 'react';
import { COLORS } from '../../constants/colors';


export const BlackButton = (props) => {
    const {onClick, title, 
        loading=false,
        height=50,
        color=COLORS.BG_DARK,
        style={width: '100%'},
        type="button"} = props
    return <Button
    sx={[{
        '&:hover': {
            color: 'white',
            backgroundColor: !loading  ? color: "gray",
        },
    }, {
        width: style?.width,
        fontWeight: 'bold',
        borderRadius: 2,
        height,
        maxWidth: 400,
        backgroundColor: !loading ? color: "rgba(83, 148, 96, 0.45)",
        color: 'white',
        opacity: loading ? .7 : 1,
    }]}
    disabled={loading}
    disableRipple={true}
    disableFocusRipple={false}
    color={"secondary"}
    type={type}
    onClick={onClick}
>
    {title}
</Button>
}
